/* eslint-disable jsx-a11y/anchor-is-valid */
import ButtonDropdown from '@concur/nui-widgets/lib/Buttons/ButtonDropdown';
import classnamesBind from 'classnames/bind';
import Icon from '@concur/nui-widgets/lib/Icon/Icon';
import { languageDetails } from '@concur/nui-intl/lib/languages';
import MenuGroup from '@concur/nui-widgets/lib/Buttons/MenuGroup';
import MenuItem from '@concur/nui-widgets/lib/Buttons/MenuItem';
import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import withNuiFormatter from '../utils/withNuiFormatter';

const LanguageDropdown = (props) => {
    const {
        classNameMap,
        cssBlock,
        formatter,
        isMayFourth,
    } = props;

    const classnames = classnamesBind.bind(classNameMap);

    const getLangHref = (lang) => {
        const query = queryString.parse(window.location.search);

        const queryWithLang = {
            ...query,
            lang,
        };

        return `${window.location.pathname}?${queryString.stringify(queryWithLang)}`;
    };

    // Generates the MenuItem list for Tier 1 Language dropdown on nui-signin
    const languageButtonMenuItems = () => Object.keys(languageDetails)
        .filter((lang) => languageDetails[lang].tier === 1)
        .map((lang) => (
            <MenuItem
                key={lang}
                href={getLangHref(lang)}
            >
                {languageDetails[lang].name}
            </MenuItem>
        ));

    return (
        <ButtonDropdown
            aria-label={formatter.formattedMessage({ id: 'CoreUI.languageMenuAriaLabel' })}
            buttonClassName={classnames(`${cssBlock}__language`)}
            dropdownMaxHeight={308}
            id="langMenuItem"
            pullRight
            size="md"
            title={(
                <>
                    <Icon ariaHidden iconName={isMayFourth ? 'not-a-moon' : 'globe'} />
                    {formatter.lang && languageDetails[formatter.lang].name}
                </>
            )}
            type="link"
        >
            <MenuGroup>
                {languageButtonMenuItems()}
            </MenuGroup>
        </ButtonDropdown>
    );
};

LanguageDropdown.displayName = 'LanguageDropdown';

LanguageDropdown.propTypes = {
    cssBlock: PropTypes.string,
    isMayFourth: PropTypes.bool,
};

export default withNuiFormatter(LanguageDropdown);
